/**
 * PostHog Survey Configuration
 *
 * These are API-type surveys configured in PostHog that are
 * displayed using custom UI and manually emit events.
 */

export const POSTHOG_SURVEYS = {
  /**
   * Task CSAT Survey - shown when users complete a task
   * Asks: "How well did the Finch app help you with your last task?"
   * Type: 5-point emoji rating scale
   */
  TASK_CSAT: {
    id: '019bb8e1-912e-0000-ce14-6e55b06d5716',
    questions: [
      {
        id: '1c2fabfe-7d69-4f7f-b58c-4f0eca84e7fc',
        question: 'How well did the Finch app help you with your last task?',
        type: 'rating' as const,
        scale: 5,
        display: 'emoji' as const,
        lowerBoundLabel: 'Very dissatisfied',
        upperBoundLabel: 'Very satisfied',
      },
    ],
  },

  /**
   * Intake V3 CSAT Survey - shown when users complete an intake (End Intake)
   * Asks: "How satisfied are you with the intake experience?"
   * Type: 5-point emoji rating scale
   */
  INTAKE_V3_CSAT: {
    id: '019c05bb-f33c-0000-528d-676a72c721ba',
    questions: [
      {
        id: 'bd0cf136-23a3-490d-9b52-279af97cc957',
        question: 'How satisfied are you with the intake experience?',
        type: 'rating' as const,
        scale: 5,
        display: 'emoji' as const,
        lowerBoundLabel: 'Very dissatisfied',
        upperBoundLabel: 'Very satisfied',
      },
    ],
  },
} as const;
